const prepareContent = (rows: Record<any, any>) => {
  return rows
    .map((row: any) =>
      row
        .map(String)
        .map((val: string) => val.replaceAll('"', ''))
        .join(','),
    )
    .join('\r\n');
};

const download = (content: string, filename = '') => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  filename ||= 'export.csv';
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.click();
  link.remove();
};

export default function downloadCsv(rows: Record<any, any>, filename = '') {
  const content = prepareContent(rows);
  download(content, filename);
}
